// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"de43373f","462":"bb319882","992":"4dc4ea58"}[chunkId] + ".chunk.js";
};